import { PeoplePickerDialogState } from './schema/Schema';
import {
    FindResultType,
    DirectorySearchType,
} from 'owa-recipient-types/lib/types/FindControlViewState';
import { createStore } from 'satcheljs';

// People picker dialog store
const peoplePickerDialogState: PeoplePickerDialogState = {
    userMailboxWrapper: null,
    findControlViewState: {
        queryString: '',
        findResultSet: [],
        findResultType: FindResultType.None,
        isSearching: false,
        directorySearchType: DirectorySearchType.None,
        findPeopleFeedbackManager: null,
        numberOfCacheResults: 0,
    },
};

export const getStore = createStore<PeoplePickerDialogState>(
    'peoplePickerDialogStore',
    peoplePickerDialogState
);

export default getStore();
